import { useMediaQuery } from "@mui/material";
import { LayoutState, MediaQueryLinebreak, MediaQueryMobile, MediaQueryShallow, MediaQuerySmall1, MediaQuerySmall2, MediaQuerySmall3, MediaQuerySmall4, MediaQuerySmall5 } from "../Layout";
import MainNavigationDesktop from "./MainNavigationDesktop";
import MainNavigationMobile from "./MainNavigationMobile";

export default function MainNavigation() {
    // Init layout parameters
    const layoutState = new LayoutState();
    layoutState.isMobile = useMediaQuery(MediaQueryMobile);
    layoutState.isShallow = useMediaQuery(MediaQueryShallow);
    layoutState.isSmall1 = useMediaQuery(MediaQuerySmall1);
    layoutState.isSmall2 = useMediaQuery(MediaQuerySmall2);
    layoutState.isSmall3 = useMediaQuery(MediaQuerySmall3);
    layoutState.isSmall4 = useMediaQuery(MediaQuerySmall4);
    layoutState.isSmall5 = useMediaQuery(MediaQuerySmall5);
    layoutState.linebreak = useMediaQuery(MediaQueryLinebreak);

    if (!layoutState.isMobile && !layoutState.isShallow ) {
        return <MainNavigationDesktop layoutState={layoutState}/>;
    }
    else if (layoutState.isMobile) {
        return <MainNavigationMobile />;
    }
    else {
        return <></>;
    }
}